<script setup>
defineProps({
    icon: {
        type: [Object, Function],
        required: false,
    },
    title: {
        type: String,
        required: false,
        default: '',
    },
    subtitle: {
        type: String,
        required: false,
        default: '',
    },
});
</script>

<template>
    <li
        class="flex flex-col items-start justify-between gap-4 py-3 leading-6 first:pt-0 last:pb-0 md:flex-row md:items-center"
    >
        <div class="flex w-full min-w-0 items-center gap-3">
            <component
                v-if="icon"
                :is="icon"
                class="size-5 shrink-0 text-gray-400 [&>svg]:size-5"
            />

            <div class="flex w-full min-w-0 flex-col">
                <span class="text-sm font-medium text-gray-700">
                    <slot>{{ title }}</slot>
                </span>

                <span
                    v-if="$slots.subtitle || subtitle"
                    class="mt-0.5 text-xs text-gray-500"
                >
                    <slot name="subtitle">{{ subtitle }}</slot>
                </span>
            </div>
        </div>

        <div v-if="$slots.actions" class="flex shrink-0 items-center gap-2">
            <slot name="actions" />
        </div>
    </li>
</template>
